import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { IStudy } from 'src/types/SiteStudyPersonal';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const studyApi = createApi({
  baseQuery,
  reducerPath: 'studyApi',
  endpoints: builder => ({
    getStudyBySiteId: builder.query<IStudy, string>({
      query: site_id => ({
        url: formatString(endPoints.study.select, {
          key: urlKeys.site_id,
          value: site_id
        }),
        transformResponse: (response: { data: IStudy }) => response.data
      })
    })
  })
});

export const { useGetStudyBySiteIdQuery } = studyApi;
